import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  createScheduleApi,
  getScheduletApi,
  updateScheduleApi,
} from "./scheduleApi";

export const getScheduleRequest = createAsyncThunk(
  "getScheduleRequest/schedule",
  async () => {
    try {
      const response = await getScheduletApi();
      console.log("RESDATSEC");

      return response;
    } catch (error) {
      throw error;
    }
  }
);

export const createScheduleRequest = createAsyncThunk(
  "createScheduleRequest/schedule",
  async (payload: any) => {
    try {
      const response = await createScheduleApi(payload);
      return response;
    } catch (error) {
      throw error;
    }
  }
);

export const updateScheduleRequest = createAsyncThunk(
  "updateScheduleRequest/schedule",
  async (payload: any) => {
    try {
      const response = await updateScheduleApi(payload);
      return response;
    } catch (error) {
      throw error;
    }
  }
);

interface IInitialState {
  scheduleList: any[];
  schedulePost: any;
  scheduleUpdate: any;
  message: string;
  isSuccess: boolean;
  pageIsLoading: boolean;
}

const initialState: IInitialState = {
  scheduleList: [],
  schedulePost: {},
  scheduleUpdate: {},
  message: "",
  isSuccess: false,
  pageIsLoading: false,
};

const scheduleSlice = createSlice({
  name: "level",
  initialState: initialState,
  reducers: {
    resetMessageSchedule: (state) => {
      state.message = "";
    },
    resetSuccessSchedule: (state) => {
      state.isSuccess = false;
    },
  },
  extraReducers(builder) {
    // get department reducer
    builder.addCase(getScheduleRequest.pending, (state) => {
      state.pageIsLoading = true;
    });
    builder.addCase(getScheduleRequest.fulfilled, (state, action) => {
      if (action.payload.status === 1000) {
        state.scheduleList = action.payload.data;
        state.pageIsLoading = false;
      } else {
        // state.message = "someting went wrong";
        state.pageIsLoading = false;
      }
    });
    builder.addCase(getScheduleRequest.rejected, (state) => {
      state.pageIsLoading = false;
    });

    // create department reducer
    builder.addCase(createScheduleRequest.pending, (state) => {
      state.pageIsLoading = true;
    });
    builder.addCase(createScheduleRequest.fulfilled, (state, action) => {
      console.log(action);

      if (action.payload.status === 1000) {
        state.schedulePost = action.payload.data;
        state.isSuccess = true;
        state.pageIsLoading = false;
      } else {
        state.message = action.payload.message;
        state.pageIsLoading = false;
      }
    });
    builder.addCase(createScheduleRequest.rejected, (state) => {
      state.message = "someting went wrong";
      state.pageIsLoading = false;
    });

    // update department reducer
    builder.addCase(updateScheduleRequest.pending, (state) => {
      state.pageIsLoading = true;
    });
    builder.addCase(updateScheduleRequest.fulfilled, (state, action) => {
      if (action.payload.status === 1000) {
        state.scheduleUpdate = action.payload.data;
        state.isSuccess = true;
        state.pageIsLoading = false;
      } else {
        state.message = action.payload.message;
        state.pageIsLoading = false;
      }
    });
    builder.addCase(updateScheduleRequest.rejected, (state) => {
      state.message = "someting went wrong";
      state.pageIsLoading = false;
    });
  },
});

export const { resetMessageSchedule, resetSuccessSchedule } =
  scheduleSlice.actions;
export default scheduleSlice.reducer;
